/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, number,
    bool, arrayOf, func, object,
} from 'prop-types';
import Slider from 'react-slick';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIosTwoTone';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIosTwoTone';
import Button from '@material-ui/core/Button';

import ReactHtmlParser from 'react-html-parser';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import Media from 'react-media';
import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { rowSpacing } from '../../../style/variables';
import { isEmpty } from '../../../utils/object';
import { decode as htmlDecode } from '../../../utils/htmlEntity';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configEnv from '../../../config';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const { PERSIST_KEY } = configEnv;

const useStyles = makeStyles((theme) => ({
    productWrapper: {
        padding: '0',
        marginTop: '28px',
        position: 'relative',
        '@media only screen and (max-width: 1024.5px) and (min-width: 600.5px)': {
            minWidth: '200px',
        },
        '@media only screen and (max-width: 600px) ': {
            minWidth: '133px',
            marginTop: '0px',
        },
    },
    productImageWrapper: {
        position: 'relative',
        cursor: 'pointer',
        '& .quickView': {
            opacity: '0',
            position: 'absolute',
            bottom: '28%',
            right: '0px',
            padding: '6px',
            transition: 'opacity 0.1s',
        },
        '&:hover': {
            '& .quickView': {
                opacity: '1',
                transition: 'opacity 0.3s',
            },
        },
    },
    productImage: {
        width: '100%',
        aspectRatio: '115/123',
        display: 'flex',
    },
    productName: {
        textOverflow: 'ellipsis',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '20px',
        textDecorationLine: 'underline',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: '2',
        fontSize: '1rem',
        minHeight: '50px',
        paddingTop: '10px',
        overflow: 'hidden',
        '@media only screen and (max-width: 1023.5px) ': {
            lineHeight: '1.125rem',
            minHeight: '44px',
        },
        '@media only screen and (max-width: 600px) ': {
            paddingTop: '8px',
        },
    },
    status: {
        marginBottom: rowSpacing,
        textTransform: 'uppercase',
        fontSize: '0.75rem',
    },
    price: {
        fontWeight: 700,
        textAlign: 'left',
        lineHeight: '1.125rem',
        padding: '8px 0px 0px',
        fontSize: '1rem',
    },
    headerTitle: {
        height: '28px',
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '20px',
        position: 'absolute',
        top: '-28px',
        left: '0px',
        width: '160px',
        '@media only screen and (max-width: 600.5px) ': {
            position: 'relative',
            width: 'auto',
            top: '0px',

        },
    },
    sliderContainer: {
        position: 'relative',
        width: '100%',
        '@media only screen and (max-width: 600.5px) ': {
            paddingBottom: '0px',
        },
        '& .slick-disabled': {
            display: 'none !important',
        },
        '& .slick-list': {
            overflow: 'hidden',
            margin: '0 auto',
            width: '100%',
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(156, 156, 156, 1)',  // scroll bar color
            },
            '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
                height: '3px',
                backgroundColor: 'transparent',
            },
            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                backgroundColor: 'transparent',
            },
        },
        '& .slick-slide': {
            display: 'inline-block',
            verticalAlign: 'top',
            padding: '0px 16px 0px 0px',
            position: 'relative',
        },
        '& .slick-slide:nth-child(2)': {
            marginLeft: '16px',
        },
        '& .slick-next': {
            right: '-4%',
            border: `1px solid ${theme.palette.headerColor || '#E8F1ED'}`,
            borderRadius: '50%',
            width: 30,
            background: theme.palette.headerColor || '#E8F1ED',
            transform: 'translate(0,-50%)',
            cursor: 'pointer',
            outline: 0,
            fontSize: 0,
            lineHeight: 0,
            top: '42%',
            height: 30,
            position: 'absolute',
            '@media only screen and (max-width: 1200px) ': {
                right: '-6%',
            },
            '& svg': {
                width: '0.6em',
                position: 'absolute',
                right: '18%',
            },
        },
        '& .slick-prev': {
            left: '-4%',
            border: `1px solid ${theme.palette.headerColor || '#E8F1ED'}`,
            borderRadius: '50%',
            width: 30,
            background: theme.palette.headerColor || '#E8F1ED',
            transform: 'translate(0,-50%)',
            cursor: 'pointer',
            outline: 0,
            fontSize: 0,
            lineHeight: 0,
            top: '42%',
            height: 30,
            position: 'absolute',
            '@media only screen and (max-width: 1200px) ': {
                left: '-6%',
            },
            '& svg': {
                width: '0.65em',
                position: 'absolute',
                right: '18%',
            },
        },
        '& .slick-track': {
            display: 'flex',
            paddingBottom: '30px',
        },
    },
    headerMainTitle: {
        lineHeight: '1.75rem',
        fontWeight: 700,
        margin: '0px',
        fontSize: '1rem',
        padding: '10px 0px ',
        '@media only screen and (max-width: 1023.5px) ': {
            lineHeight: '1.25rem',
        },
    },
    buttonContainer: {
        '@media only screen and (max-width: 1130px) and (min-width: 1025px)': {
            padding: '6px',
        },
        '@media only screen and (max-width: 600.5px) ': {
            display: 'block',
            padding: '6px 0px',
            minHeight: '36px',
        },
        '& .MuiButton-label': {
            '& span': {
                paddingLeft: '5px',
                '@media only screen and (max-width: 600.5px) ': {
                    display: 'block',
                    paddingLeft: '0px',
                },
            },
        },
        backgroundColor: theme.palette.cms?.white || '#ffffff',
        margin: '0px ',
        padding: '8px ',
        width: '100% ',
        fontWeight: 700,
        border: `1px solid ${theme.palette.cms?.black || '#2F2F2F'}`,
        color: theme.palette.cms?.black || '#2f2f2f ',
        lineHeight: '20px',
        boxShadow: 'inherit !important',
        letterSpacing: ' 0.56px',
        textTransform: 'capitalize',
        borderRadius: '3px',
        minHeight: '44px',
        marginTop: '20px',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: theme.palette.cms?.white || '#ffffff',
            color: theme.palette.cms?.black || '#2f2f2f',
        },
        '& .MuiTouchRipple-root span': {
            display: 'none !important',
        },
    },
    sendGift: {
        backgroundColor: theme.palette.secondary?.main || '#a1001a',
        color: theme.palette.cms?.white || '#ffffff',
        border: `1px solid ${theme.palette.secondary?.main}` || '#a1001a', // TODO
        '&:hover': {
            backgroundColor: theme.palette.secondary?.main || '#a1001a',
            color: theme.palette.cms?.white || '#ffffff',
        },
    },
    content: {
        fontWeight: 'normal',
        '@media only screen and (max-width: 600.5px) ': {
            display: 'block ',
        },
    },
    otherRecommendationContainer: ({ sliderProductLength }) => ({
        display: 'grid',
        gridTemplateColumns: `repeat(${sliderProductLength}, 1fr)`,
        overflowY: 'auto',
        padding: '12px 0px 8px',
        columnGap: '1rem',
        marginBottom: '12px',
        '@media only screen and (max-width: 1023.5px) ': {
            paddingBottom: '12px',
        },
        '@media only screen and (max-width: 600.5px) ': {
            padding: '0px 0px 12px',
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: 'rgba(156, 156, 156, 1)',  // scroll bar color
        },
        '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
            height: '3px',
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            backgroundColor: 'transparent',
        },
    }),
    crossedPrice: {
        textDecoration: 'line-through',
        fontWeight: 700,
    },
    discountPrice: {
        paddingLeft: '5px',
        color: theme.palette.cms?.errorZipVerifyPDP || '#A1001A',
    },
    bestMatch: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.green || '#387154',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        fontWeight: 700,
        paddingBottom: '8px',
        '@media only screen and (max-width: 768.5px) ': {
            fontSize: '0.875rem',
            lineHeight: '1.125rem',
        },
        '& img': {
            paddingRight: '8px',
        },
    },
    previousGift: {
        color: theme.palette.green || '#387154',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        paddingBottom: '10px',
        '& span': {
            fontWeight: 700,
        },
        '@media only screen and (max-width: 768.5px) ': {
            fontSize: '0.875rem',
            lineHeight: '1.125rem',
        },
    },
    borderRight: {
        position: 'absolute',
        width: '2px',
        height: '92%',
        top: '28px',
        background: '#9C9C9C',
        right: '0',
    },
    wrapper: {
        position: 'relative',
        '& $borderRight': {
            right: '-16px',
        },
        '&:nth-child(2)': {
            marginLeft: '16px',
            '@media only screen and (max-width: 600.5px) ': {
                marginTop: '28px',
            },
        },
        '&:nth-child(2) $headerTitle': {
            '@media only screen and (max-width: 600.5px) ': {
                position: 'absolute',
                top: '-28px',
                left: '0px',
                width: '160px',
            },
        },
    },
    container: {
        '& .slick-slide:nth-child(2)': {
            marginLeft: '0px',
        },
        '& $borderRight': {
            display: 'none',
        },
        '& $wrapper': {
            '&:nth-child(2)': {
                marginLeft: '0px',
                '@media only screen and (max-width: 600.5px) ': {
                    marginTop: '0px',
                },
            },
        },
        '& $productWrapper': {
            marginTop: '0px',
        },
    },
}));
const OtherRecommendation = ({
    recipient, handleGiftListAddToCart, history,
    history: { location: { pathname: giftListURL } },
    remainingRecipient,
    handleConfirmGiftListShopTheSiteClicked,
    setOpen, setData,
}) => {
    const dispatch = useDispatch();
    let ldClient;
    const ffIsGiftlistV2Enabled = useSelector(getFeatureFlag('is-giftlist-v2-enabled'));
    if (ffIsGiftlistV2Enabled && typeof window !== 'undefined') {
        ldClient = useLDClient();
    }
    const handleAddToCart = (productId) => {
        handleGiftListAddToCart(productId, recipient);
        dispatch(trackEvent({
            eventCategory: 'Gift List V2',
            eventAction: 'Item Added',
            eventLabel: productId || '',
        }));
        dispatch(trackEvent({
            eventCategory: 'Gift List V2',
            eventAction: 'Recommended item added',
            eventLabel: productId || '',
        }));
    };
    const sliderProduct = recipient?.products;
    const isMobile = useMediaQuery('(max-width: 600px)');
    const classes = useStyles({ sliderProductLength: sliderProduct?.length });
    const  handleAddToCartClicked = (product, specialProduct) => {
        if (ffIsGiftlistV2Enabled) { ldClient.track('Add to Cart'); }
        if (specialProduct) {
            const { seoproductDisplayURL, customAttributes } = product;
            const recipientWithCounter = { ...recipient, remainingRecipient, giftListURL };
            handleConfirmGiftListShopTheSiteClicked(
                recipientWithCounter,
                seoproductDisplayURL || customAttributes?.parentProduct?.seo?.url,
                false,
            );
            if (seoproductDisplayURL) history.push(seoproductDisplayURL);
            else if (customAttributes?.parentProduct?.seo?.url) history.push(customAttributes?.parentProduct?.seo?.url);
        } else {
            handleAddToCart(product.id, recipient);
        }
    };
    const renderHeaderBestMatch = () => (
        <div className={classes.bestMatch}>
            <img src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/bltaddfbbb89c5b8da4/6346ed8f8edd6411a37ce5c9/ribbon_star.svg?auto=webp" alt="ribbon" />
            <span>Best Match</span>
        </div>
    );
    const productNumber = recipient.previousItemMetadata?.partNumber || '';
    const currentPartNumber = recipient?.currentItempartNumber || '';

    const headerProduct = (indexProduct) => {
        let headerTittle = ' ';
        if (productNumber && currentPartNumber) {
            if (indexProduct === 0) {
                headerTittle = productNumber !== currentPartNumber ? renderHeaderBestMatch() : <span className={classes.previousGift}>Sent previously</span>;
            } else if (indexProduct === 1) {
                headerTittle = 'Other recommendations';
            }
            return <div className={classes.headerTitle}>{headerTittle}</div>;
        }
        return null;
    };

    const  productTemplate = (
        product, index,
    ) => {
        const {
            id,
            name,
            image,
            status,
            price,
            discountPrice,
            crossedPrice,
            customAttributes: { personalization, parentProduct },
            customAttributes,
            hasItemSendPrevious,
        } = product;
        const urlDecode = name || '';
        const newName = htmlDecode(urlDecode);
        const imageURL = (image) ? image.replace(/^http[s]?:/, 'https:') : '';
        const ageVerifyFlag = (!isEmpty(customAttributes) && customAttributes?.ageVerifyFlag) ? customAttributes.ageVerifyFlag : 'false';
        const personalizationTemplate = (!isEmpty(personalization) && personalization?.personalizationTemplate) ? personalization.personalizationTemplate : 'N';
        const personalizationType = (!isEmpty(personalization) && personalization?.personalizationType) ? personalization.personalizationType : null;
        const specialProduct = ageVerifyFlag !== 'false'
            || parentProduct?.productType === 'CLUB'
            || parentProduct?.productType === 'COLLECTION'
            || parentProduct?.productType === 'CUSTOM_ASSORTMENT'
            || (
                !['REGULAR_PRODUCT', 'REGULARPRODUCT'].includes(parentProduct?.productType)
                && (
                    personalizationTemplate === 'Y'
                    || personalizationType === 'G'
                    || personalizationType === '0'
                )
            );

        let defaultAddToCartLabel = 'Add To Cart';
        if (specialProduct) {
            defaultAddToCartLabel = 'Make Selections';
        }

        if (index === 0 && hasItemSendPrevious) {
            defaultAddToCartLabel = 'Send Same Gift';
        }

        return (
            <div
                key={id}
                className={classes.productWrapper}
            >
                {headerProduct(index)}

                <div
                    role="button"
                    tabIndex="-1"
                    className={classes.productImageWrapper}
                    onClick={() => {
                        setOpen(true);
                        setData(product);
                    }}
                    onKeyDown={() => setOpen(true)}
                >
                    <div className="quickView"><img src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/bltce8bf45146ae62fe/63346b4b0046bd180f978e23/quick_view.svg?auto=webp" alt="quick view" /></div>
                    {
                        imageURL
                            && <img src={`${imageURL}?width=200&auto=webp`} alt={newName} className={classes.productImage} />
                    }

                    {newName && (
                        <div className={classes.productName}>
                            {ReactHtmlParser(newName)}
                        </div>
                    )}
                    {status && (<div className={classes.status}>{status}</div>)}
                    <div className={classes.price}>
                        {discountPrice && crossedPrice ? (
                            <>
                                <span className={classes.crossedPrice}>
                                    ${crossedPrice}
                                </span>
                                <span className={classes.discountPrice}>
                                    ${discountPrice}
                                </span>
                            </>
                        ) : (
                            `$${price}`
                        )}
                    </div>
                </div>
                <Button
                    variant="contained"
                    className={`${classes.buttonContainer} ${index === 0 && hasItemSendPrevious ? classes.sendGift : ''}`}
                    onClick={() => handleAddToCartClicked(product, specialProduct)}
                >
                    {ReactHtmlParser(defaultAddToCartLabel)}
                </Button>
            </div>
        );
    };
    return (
        <div className={(productNumber && currentPartNumber) ? '' : classes.container}>
            <Media query="(min-width: 1024.5px)">
                {(matches) => (matches
                    ? (
                        <Slider
                            className={classes.sliderContainer}
                            dots={false}
                            infinite={false}
                            speed={500}
                            slidesToShow={isMobile ? 2.5 : 5.2}
                            initialSlide={0}
                            slidesToScroll={2}
                            arrows
                            nextArrow={<div><ArrowForwardIosIcon /></div>}
                            prevArrow={<div><ArrowBackIosIcon /></div>}
                        >
                            {sliderProduct?.map((product, index) => (
                                <>
                                    {productTemplate(product, index)}
                                    {index === 0 ? <div className={classes.borderRight} /> : ''}
                                </>
                            ))}

                        </Slider>
                    )
                    : (
                        <div className={classes.otherRecommendationContainer}>
                            {sliderProduct?.map((product, index) => (
                                <div key={product?.id} className={classes.wrapper}>
                                    {productTemplate(product, index)}
                                    {index === 0 ? <div className={classes.borderRight} /> : ''}
                                </div>
                            ))}
                        </div>
                    )
                )}
            </Media>
        </div>
    );
};

OtherRecommendation.defaultProps = {
    history: {},
    recipient: {},
    handleGiftListAddToCart: () => {},
    handleConfirmGiftListShopTheSiteClicked: () => {},
    setOpen: () => {},
    setData: () => {},
};

OtherRecommendation.propTypes = {
    history: object,
    recipient: shape({
        AddressBookEntryId: string,
        addToCart: string,
        address: shape({
            addressId: string,
            apt: string,
            city: string,
            company: string,
            street: string,
            zipcode: string,
        }),
        addressId: string,
        firstname: string,
        giftArrived: string,
        id: string,
        isNewRecipient: bool,
        lastname: string,
        occasionId: string,
        orderItemId: string,
        products: arrayOf(
            shape({
                id: string,
                image: string,
                name: string,
                partNumber: string,
                price: number,
                sku: string,
                status: string,
            }),
        ),
        type: string,
    }),
    remainingRecipient: number.isRequired,
    handleConfirmGiftListShopTheSiteClicked: func,
    handleGiftListAddToCart: func,
    setOpen: func,
    setData: func,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        remainingRecipient: newState.giftList?.remainingRecipient,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListAddToCart: (productId, recipient, closeModal) => dispatch(EventDispatcher.handleGiftListAddToCart(
        productId,
        recipient,
        closeModal,
        'desktop',
    )),
    handleConfirmGiftListShopTheSiteClicked: (recipient, url, dontShowModal) => dispatch(EventDispatcher.handleConfirmGiftListShopTheSiteClicked(
        recipient,
        url,
        dontShowModal,
    )),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(OtherRecommendation));
